<template><div><h1>VUX V2.7.8 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 修复 `on-hide` 事件触发两次的问题 #2379</li>
<li>[fix] 修复初始化时 `show` 值为 `true` 无效的问题</li>
</ul>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[fix] 修复多级联动模式下，子代没有数据时，取值不正确。</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[fix] 修复 popup-radio 组件不支持cell组件中 border-intent 的属性。</li>
</ul>
<h2><a href="/zh-CN/components/wechat.html">Wechat</a></h2>
<ul><li>[feature] 使用 1.3.0 版本，废弃依赖 weixin-js-sdk</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.8 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.8-265.vue?40e02c86